import httpUtils from '../../utils/HttpUtils'

class OnestopProjectService {

  //整包方案列表
  async getOnestopCaseList (companyId='') {
    console.log('整包案例方案列表');
    var result = null;
    try {
      result = await httpUtils.post('/onestop/case/list',{companyId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //整包方案详情
  async getOnestopCaseDetail (id) {
    console.log('整包案例方案详情');
    var result = null;
    try {
      result = await httpUtils.post('/onestop/case/detail',{id});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //获取项目阶段详情
  async nodeList (projectId = '',stageId = '') {
    console.log('获取监理、工长的整包项目详情');
    let result = null;
    try {
      result = await httpUtils.post('/server/project/inspect/node/list',{projectId,stageId})
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //获取项目阶段详情
  async nodeImageList (projectId = '',stageId = '') {
    console.log('获取监理、工长的整包项目详情');
    let result = null;
    try {
      result = await httpUtils.post('/server/project/inspect/node/image/list',{projectId,stageId})
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //附近工地
  async getOnestopProjectNear (pageNo = 1) {
    var result = null;
    try {
      result = await httpUtils.post('/server/onestop/project/near',{pageNo});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new OnestopProjectService()
